import { render } from "./SFormSubmitPage.vue?vue&type=template&id=1769721c&ts=true"
import script from "./SFormSubmitPage.vue?vue&type=script&lang=ts"
export * from "./SFormSubmitPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__